import React, { useEffect, useState } from 'react';
import { Row, Col, InputGroup, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';

export default function SalidasBodega() {
    const { token, user } = useAuth();
    const minDate = new Date(2007, 0, 1);
    const maxDate = new Date(); // Today
    const [cargando, setCargando] = useState(false);
    const [fechaInicial, setFechaInicial] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [salidas, setSalidas] = useState([]);
    const [swalProps, setSwalProps] = useState({})
    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            width: '7%',
        },
        {
            name: 'Fecha',
            selector: row => row.det_fecha,
            sortable: true,
            width: '7%',
            format: row => row.det_fecha ? row.det_fecha.split('T')[0] : '',
        },
        {
            name: 'Hora',
            selector: row => row.det_hora,
            sortable: true,
            width: '7%',
        },
        {
            name: 'Ayuda',
            selector: row => row.ayu_ayuda,
            sortable: true,
            width: '25%',
        },
        {
            name: 'Entidad',
            selector: row => row.ent_entidad,
            sortable: true,
            width: '11%',
        },
        {
            name: 'Cantidad vieja',
            selector: row => row.det_cantidadvieja,
            sortable: true,
            width: '10%',
        },
        {
            name: 'Cantidad actual',
            selector: row => row.det_cantidadactual,
            sortable: true,
            width: '10%',
        },
        {
            name: 'Usuario',
            selector: row => row.det_usuario,
            sortable: true,
            width: '20%',
        },
        {
            name: 'Id detalle',
            selector: row => row.det_iddetalleatencion,
            sortable: true,
            width: '15%',
        }
    ];
    const exportarSalidasExcel = () => {
        if (!salidas || salidas.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(salidas);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "SalidasBodega");
        XLSX.writeFile(workbook, "salidas_bodega.xlsx", { bookType: "xlsx" });
    };
    const ConsultarSalidasBodega = async () => {
        const url = '/bodega/consultaregresobodega';
        const obj = {
            fechaInicio: fechaInicial ? fechaInicial.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if(result.egresosbodega){
                setSalidas(result.egresosbodega);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Egresos Bodega AHE"
                idCabezaFamilia="1"
                url="/bodega/ahe"
                nombreurl="AHE"
                nombreform="Consulta egresos bodega AHE"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Consulta egresos bodega AHE</h3>
                                </div>
                                <div className="card-body">
                                    <h5 className="mb-12">Por fechas</h5>
                                    <Row className="mb-12" style={{ padding: '10px', display: 'flex', alignItems: 'center' }}>
                                    <Col md={6}>
                                        <InputGroup>
                                        <InputGroup.Text>Fecha inicio</InputGroup.Text>
                                        <DatePicker
                                            selected={fechaInicial}
                                            onChange={date => setFechaInicial(date)}
                                            minDate={minDate}
                                            maxDate={fechaFin || maxDate}
                                            dateFormat="dd/MM/yyyy"
                                            className="form-control"
                                            placeholderText="Seleccione fecha inicio"
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={6}>
                                        <InputGroup>
                                        <InputGroup.Text>Fecha fin</InputGroup.Text>
                                        <DatePicker
                                            selected={fechaFin}
                                            onChange={date => setFechaFin(date)}
                                            minDate={fechaInicial || minDate}
                                            maxDate={maxDate}
                                            dateFormat="dd/MM/yyyy"
                                            className="form-control"
                                            placeholderText="Seleccione fecha fin"
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Row className="mb-3">
                                    <Col>
                                        <fieldset className="btn-group w-100 flex-wrap" aria-label="Opciones de consulta">
                                        <Button variant="primary" onClick={ConsultarSalidasBodega} className="mb-2 me-2">
                                            Buscar
                                        </Button>
                                        </fieldset>
                                    </Col>
                                    </Row>
                                </div>
                                <div className="card-body">
                                    <Button variant="success" onClick={exportarSalidasExcel} className="mb-2 me-2">
                                        Exportar CSV
                                    </Button>
                                    <DataTable
                                        columns={columns}
                                        data={salidas}
                                        pagination
                                        highlightOnHover
                                        dense
                                        noDataComponent="No hay egresos para mostrar"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}